import { FunctionalComponent, h } from "preact";
import * as style from "./style.less";

const Footer: FunctionalComponent = () => {
  return (
    <footer class={style.footer}>
      <div class={style.content}>
        <div class={style.conl}>
          <a
            class={style.logo}
            href={process.env.PAGE_HOME}
            title="一起剪"
          >
            <h1>一起剪</h1>
          </a>
          <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备20059828号</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602009154">粤公网安备 44010602009154号</a>
        </div>
        <div class={style.conr}>
          <div class={style.items}>
            <h4>产品</h4>
            <ul>
              <li><a href={process.env.PAGE_MATERIAL} target="_blank">海量剪辑素材</a></li>
              <li><a href={process.env.PAGE_VIDEO_COLLECTOR} target="_blank">智能创作工具库</a></li>
              <li><a href={process.env.PAGE_VIDEO_TEMPLATES} target="_blank">视频模版定制</a></li>
              <li><a href={process.env.PAGE_SMART_EDITOR} target="_blank">智能在线剪辑</a></li>
              <li><a href={process.env.PAGE_AUTO_SOUNDS} target="_blank">AI智能语音</a></li>
              <li><a href={process.env.PAGE_CLOUD_MAKER} target="_blank">视频云端合成</a></li>
            </ul>
          </div>
          <div class={style.items}>
            <h4>合作</h4>
            <ul>
              <li><a href={process.env.PAGE_DEPLOY} target="_blank">私有部署</a></li>
              <li><a href={process.env.PAGE_OPEN_ACCESS} target="_blank">开放接入</a></li>
              <li><a href="//rongmeiti.myzaker.com/" target="_blank">融媒体解决方案</a></li>
            </ul>
          </div>
          <div class={style.items}>
            <h4>会员</h4>
            <ul>
              <li><a href={process.env.PAGE_VIP} target="_blank">订购计划</a></li>
            </ul>
          </div>
          <div class={style.items}>
            <h4>友情连接</h4>
            <ul>
              <li><a href="//rongmeiti.myzaker.com/" target="_blank">融媒体解决方案</a></li>
              <li><a href="//www.myzaker.com/" target="_blank">ZAKER新闻</a></li>
              <li><a href="//www.z-metaspace.com/" target="_blank">宙世代元宇宙</a></li>
            </ul>
          </div>
          <div class={style.items}>
            <h4>联系我们</h4>
            <ul>
              <li>
                <a href="javascript:;" target="_blank">一起剪官方号</a>
                <div class={style.pop}>
                  <img
                    src="//zkvideo-oss.myzaker.com/yiqijian/images/customer_service.jpg"
                    alt="一起剪官方号"
                  />
                </div>
              </li>
              <li>
                <a href="javascript:;" target="_blank">创作者交流群</a>
                <div class={style.pop}>
                  <img
                    src="//zkvideo-oss.myzaker.com/yiqijian/images/group_chat.png"
                    alt="创作者交流群"
                  />
                </div>
              </li>
              <li><a href="mailto:lifenni@myzaker.com" rel="nofollow">lifenni@myzaker.com</a></li>
              <li><a href="mailto:support@yiqijian.com" rel="nofollow">support@yiqijian.com</a></li>
            </ul>
          </div>
          <div class={style.items}>
            <h4>商务咨询</h4>
            <ul>
              <li><a href="tel:020-38465849" title="电话" rel="nofollow">020-38465849</a></li>
              <li><a href="tel:13570964521" title="电话" rel="nofollow">13570964521</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class={style.tips}>
        <span className="zk-iconfont zk-xiushiyinhao"></span>
        全球首个免费AI视频创作智能体
      </div>

      {/*
      <span class={style.copyright}></span>
      <span class={style.links}>友情链接： <a href="https://meta.zaker.cn/solution/partybuilding/" title="元宇宙党建" target="_blank">元宇宙党建</a>  <a href="https://meta.zaker.cn/solution/culturaltourism/" title="元宇宙文旅" target="_blank">元宇宙文旅</a> <a href="https://rongmeiti.myzaker.com/" title="融媒体解决方案" target="_blank">融媒体解决方案</a></span>
      <span class={style.onRecordBox}>
        <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备20059828号</a>
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602009154"><img style="margin-right: 4px" src="http://www.myzaker.com/images/new/bottom/ga.png" />粤公网安备 44010602009154号</a>
      </span>
      */}
      {/*
      <p class={style.fixedTips}>
        <span class={style.tipsContent}>
          电脑浏览器打开 <strong>yiqijian.com</strong> 免费使用
        </span>
      </p>
      */}
    </footer>
  );
};

export default Footer;
